module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('Form', [_c('FormItem', {
    attrs: {
      "label": _vm.l('JIHUAMINGCHENG')
    }
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('NIANDU')
    }
  }, [_vm._v(_vm._s(_vm.item.year) + _vm._s(_vm.l("NIAN")))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SUOSHUZUZHI')
    }
  }, [_vm._v(_vm._s(_vm.item.domainName))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('GUANLIWEIDU')
    }
  }, [_vm._v(_vm._s(_vm.item.dimensionNames))])], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "m-b"
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('YUSUANHEJI')
    }
  }, [_vm._v(_vm._s(_vm.item.sumExpenseBudget))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('RENCIHEJI')
    }
  }, [_vm._v(_vm._s(_vm.item.sumExpectedPeoples))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('KESHIHEJI')
    }
  }, [_vm._v(_vm._s(_vm.item.sumExpectedClassHours))])], 1)], 1), _vm._v(" "), _c('table', {
    staticClass: "plan-table"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.l("PEIXUNZHUYAONEIRONG")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.l("PEIXUNDUIXIANG")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.l("KECHENGMULU")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.l("PEIXUNXINGSHI")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.l("PEIXUNLEIXING")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.l("KAOHEFANGSHI")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.l("FEIYONGYUSUAN")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.l("JIHUARENSHU")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.l("JIHUAKESHI")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.l("PEIXUNYUEFEN")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.l("JIANGSHI")))])]), _vm._v(" "), _vm._l((_vm.item.planDetailList), function(i, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(i.trainingContent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.trainObject))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.courseTypeName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.trainFormName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.trainTypeName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.testMethodName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.expenseBudget) + _vm._s(_vm.l("YUAN")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.expectedPeoples))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.expectedClassHours))]), _vm._v(" "), _c('td', _vm._l((i.months), function(month, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(month) + _vm._s(_vm.l("YUE")) + ",")])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.teacherNames))])])
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-225d4991"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/shared/views/yearPlan.vue
// module id = 915
// module chunks = 80